<div class="folder-drop-target relative flex h-full min-h-0 flex-col"
  appDroppable appDroppableHoverClass="drag-over"
  [appDroppablePredicate]="canDropBoards"
  [appDroppableDisabled]="folder().deleted || folder().archived"
  (appDroppableDrop)="dropBoards($event)">
  <div class="drop-area-border" aria-hidden="true"></div>
<!-- The other apps' detail header (`skin-detail-heading`), as the board preview's: 12px / 16px in, the title 16px
     medium on a 28px line, starting on the same line as the dates under it. -->
<div class="skin-detail-heading flex shrink-0 items-center gap-4">
  <app-input class="min-w-0 flex-1" appearance="sapphire-inline" size="s" placeholder="New Folder"
    [inputFormControl]="form.controls.title" [disabled]="folder().deleted || saving()" />
  <app-button2 appearance="secondary-ghost" size="xs" [ariaLabel]="folder().archived ? 'Restore from archive' : 'Archive'" (click)="archive()">
    <app-icon name="sapphire-archive" size="s" />
  </app-button2>
  <app-button2 appearance="secondary-ghost" size="xs" [ariaLabel]="folder().deleted ? 'Restore from trash' : 'Trash'" (click)="trash()">
    <app-icon name="sapphire-trash" size="s" />
  </app-button2>
  <app-button2 appearance="secondary-ghost" size="xs" ariaLabel="More" stchPopover stchPopoverTrigger="click"
    stchPopoverPlacement="bottomRight" [stchPopoverContent]="menu" [disabled]="dirty() || saving() || uploading()">
    <app-icon name="sapphire-ellipsis" size="s" />
  </app-button2>
  <app-button2 appearance="secondary-ghost" size="xs" ariaLabel="Close folder" (click)="close()">
    <app-icon name="sapphire-close" size="s" />
  </app-button2>
</div>
<!-- The board preview's dates row: 24px tall, the dates centred in it, and 14px of its own padding to the tabs. -->
<div class="shrink-0 pb-7">
  <app-stitch-timestamps class="flex min-h-[24px] items-center" [createdAt]="folder().createdAt" [updatedAt]="folder().updatedAt" />
</div>
<!-- One 1px Gray/200 rule under the tabs, as the other apps' detail headers (`.tabs`), not the old 2px line; the
     tabs stand on it (`skin-detail-tabs > app-tabs`). -->
<div class="skin-detail-tabs !mt-0 flex h-[42px] shrink-0 items-center gap-4 border-b border-gray-200 px-8">
  <app-tabs class="min-w-0 flex-1" appearance="sapphire" size="m" [values]="tabs" [value]="tab()" (valueChange)="tab.set($event)" />
  <stch-knowledge-button [active]="displayKnowledge()" (click)="displayKnowledge.set(!displayKnowledge())" />
</div>
@if (tab() === 'stitch' && hasKnowledgeHubAccess()) {
  <app-entity-hub-search [contactId]="folder().id" />
}
@if (displayKnowledge() && (tab() !== 'stitch' || hasKnowledgeHubAccess())) {
  <!-- The other apps' one Knowledge box (styles.tw.css `.form-knowledge`), as the board preview's `app-board-knowledge`
       draws it: a Gray/200-lined card under the tabs, rows in the skin's order Knots · Tags · Connections. -->
  <div class="form-heading block max-h-[320px] shrink-0 overflow-y-auto bg-white">
    <div class="form-knowledge">
      <app-knots class="form-knots" [stitchItems]="[summary()]" [withControls]="tab() !== 'stitch' && !folder().deleted" [stateKey]="StateKey.knotsList" [isHubMode]="tab() === 'stitch' && hasKnowledgeHubAccess()" [hubEntityUid]="folder().id" />
      <app-tags class="form-tags" [stitchItems]="[summary()]" [withControls]="tab() !== 'stitch' && !folder().deleted" [stateKey]="StateKey.tagsList" [isHubMode]="tab() === 'stitch' && hasKnowledgeHubAccess()" [hubEntityUid]="folder().id" />
      <app-connections class="form-knots" [stitchItems]="[summary()]" [withControls]="tab() !== 'stitch' && !folder().deleted" [stateKey]="StateKey.connectionsList" [isHubMode]="tab() === 'stitch' && hasKnowledgeHubAccess()" [hubEntityUid]="folder().id" />
    </div>
  </div>
}
@if (error()) { <p class="px-8 py-4 text-error" role="alert">{{ error() }}</p> }
<div class="min-h-0 flex-1" [class.overflow-y-auto]="!(tab() === 'stitch' && hasKnowledgeHubAccess())" [class.overflow-hidden]="tab() === 'stitch' && hasKnowledgeHubAccess()">
  @switch (tab()) {
    @case ('boards') {
      <!-- The other apps' container page (detail-pages.css `.container-list-bar`): the list's sort & filter on an
           Off White bar of its own above the boards, and the list under it, pagination bar included, Off White too. -->
      <div class="flex h-full flex-col bg-offwhite">
        <div class="container-list-bar">
          <app-context-menu-state-indicator svgIcon="filters" appBoardsListContextMenu />
        </div>
        <app-boards-list class="min-h-0 flex-1" [showHeader]="false" [drivesPreview]="false"
          (openBoard)="openBoard($event.id)" (doubleClickBoard)="openBoard($event.id)"
          (previewBoard)="openBoard($event.id)" />
      </div>
    }
    @case ('details') {
      <div class="flex flex-wrap gap-8 p-8">
        <span>Description</span>
        <app-editable-textarea class="w-full max-w-[340px]" appearance="sapphire-outline" placeholder="Description"
          [inputFormControl]="form.controls.description" [disabled]="folder().deleted || saving()" [withClear]="true" />
      </div>
    }
    @case ('stitch') {
      @if (permissionsLoaded()) {
        @if (hasKnowledgeHubAccess()) {
          <app-stitch-hub class="h-full" [stitch]="summary()" [withUnlink]="!folder().deleted" [withUnlinkAll]="!folder().deleted" [unlinkParentPairsOnly]="true" (clickStitchItem)="openItem($event)" (dblClickStitchItem)="openItem($event)" />
        } @else {
          <app-linked-info-list class="block p-8" [stitch]="summary()" [withUnlink]="!folder().deleted" [withUnlinkAll]="!folder().deleted" [unlinkParentPairsOnly]="true" (clickStitchItem)="openItem($event)" (dblClickStitchItem)="openItem($event)" />
        }
      }
    }
    @case ('comments') { <stch-comments class="block p-8" [stitch]="summary()" [readOnly]="!!folder().deleted" /> }
  }
  <!-- Keep an upload bound to its folder when another tab is selected. -->
  <div class="p-8" [hidden]="tab() !== 'attachments'">
    <app-attachments-list [stitchItem]="summary()" [inputControl]="uploads" contextMenuStateVariant="board-folders"
      (uploading)="uploading.set($event)" (onClickItem)="openItem($event)" (onDblClickItem)="openItem($event)" />
  </div>
</div>
<stch-save-cancel-panel [enabled]="dirty()" [uploading]="saving() || uploading()" (onSave)="save()" (onCancel)="reset()" />
<ng-template #menu>
  <!-- A right-click menu, so the same edge as one: no window padding (Johanna, 2026-10-28). -->
  <app-context-menu-window class="!gap-0 !p-0">
    <app-boards-folder-context-menu [folder]="folder()" (open)="$event && selectContents()" (deleted)="close()" />
  </app-context-menu-window>
</ng-template>

</div>
